<script>
  import { createEventDispatcher } from 'svelte'
  import Switch from 'smelte/src/components/Switch'
  import FaIcon from 'fa-svelte'
  import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'

  export let sp = {value: false}

  let oldValue = null

  const dispatch = createEventDispatcher()

  $: onChange(sp.value)

  function onChange (value) {
    if (oldValue == value) {
      return
    }
    if (oldValue == null) {
      oldValue = value
      return
    }
    oldValue = value
    dispatch('change', sp)
  }

  function plusHandler () {
    sp.quantity += 1
    dispatch('change', sp)
  }

  function minusHandler () {
    if (sp.quantity > 1) {
      sp.quantity -= 1
      dispatch('change', sp)
    }
  }
</script>

<div class="flex items-center h-8">
  <div class="cursor-pointer" on:click={minusHandler}>
    <FaIcon icon={faMinus} />
  </div>

  <div class="w-16 text-center">{sp.quantity}</div>

  <div class="cursor-pointer mr-12" style="font-size: 0.8em" on:click={plusHandler}>
    <FaIcon icon={faPlus} />
  </div>

  <div class="cart-switch" style="padding-top: 0.5em">
    <Switch label="Add to cart" color="red" bind:value={sp.value} />
  </div>
</div>
